import { Component, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { getViewportSizes } from '../../../utils/sizes.util';
import { HeaderNavigationMobileComponent } from './components/header-navigation-mobile/header-navigation-mobile.component';
import { menuItems } from './utils/menu';
import { SharedModule } from '@apps/landing/src/app/shared/shared.module';
import { AppTheme, ThemeService } from '@apps/landing/src/app/shared/services/theme.service';
import { PAGE_ROUTES } from '@apps/landing/src/app/shared/constants/routes.enum';

@Component({
  selector: 'app-header',
  imports: [RouterLink, RouterLinkActive, HeaderNavigationMobileComponent, HlmButtonDirective, SharedModule],
  templateUrl: './header.component.html',
  standalone: true,
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  private readonly themeService = inject(ThemeService);

  protected readonly employeePortalUrl = signal<string>('https://portal.sapec.md');
  protected currentTheme: AppTheme;
  protected isThemeChecked: boolean;

  protected readonly PAGE_ROUTES = PAGE_ROUTES;
  protected readonly menuItems = menuItems;
  protected readonly viewportSizes = getViewportSizes();

  ngOnInit(): void {
    this.checkStorageTheme();
  }

  protected selectTheme() {
    let theme;
    if (this.currentTheme.isDark) {
      theme = this.themeService.findTheme('light');
    } else {
      theme = this.themeService.findTheme('dark');
    }

    if (!theme) {
      return;
    }

    this.themeService.setTheme(theme);
    this.currentTheme = theme;

    localStorage.setItem('theme', this.currentTheme.name);
    this.appendDarkThemeBodyClass(this.currentTheme.isDark || false);
  }

  private appendDarkThemeBodyClass(checked: boolean) {
    if (checked) {
      document.body.classList.add('dark');
    } else {
      this.removeDarkModeClass();
    }
  }

  private removeDarkModeClass() {
    document.body.classList.remove('dark');
  }

  private checkStorageTheme() {
    this.currentTheme = this.themeService.defaultTheme;

    const themeName = localStorage.getItem('theme');
    if (themeName) {
      const foundTheme = this.themeService.findTheme(themeName);
      this.isThemeChecked = themeName === 'dark';
      if (foundTheme) {
        this.themeService.setTheme(foundTheme);
        this.currentTheme = foundTheme;
      }
    } else {
      const foundTheme = this.themeService.findTheme(this.themeService.defaultTheme.name);
      if (foundTheme) {
        this.themeService.setTheme(foundTheme);
        this.currentTheme = foundTheme;
      }
      this.isThemeChecked = false;
    }

    document.body.classList.add(themeName!);
  }
}
